export default {
    account: {
        login: "/account/login"
    },
    material: {
        batchGetMaterial: "/wechat/batchGetMaterial",
        addMaterial: "/wechat/addMaterial",
    },
    menu: {
        menus: "/wechat/menus",
        menu: "/wechat/menu"
    },
    messageReply: {
        messages: "messageReply/messages",
        message: "messageReply/message",
        messageEnable: "messageReply/message/enable"
    }
}